import {
  Grid,
  Table,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@mui/material";
import PageLayout from "../common/PageLayout";
import { useLocation } from "react-router-dom";
import { BsFiles } from "react-icons/bs";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { notifyShowErrorMessage } from "../../store/AlertSlice";
import { ErrorMessageResolver } from "../common/ErrorMessageResolver";
import { AuditEventLogsRepository } from "../repositories/AuditEventLogRepository";
import { AuditEventsTable } from "./AuditEventsTable";
import { AuditEventsFilter } from "./AuditEventsFilter";

export const AuditEventsLog = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const [data, setData] = useState();
  const [filterParams, setFilterParams] = useState({});
  const [orderBy, setOrderBy] = useState("timestamp");
  const [orderDirection, setOrderDirection] = useState("DESC");

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getAll(0, 15);
  }, []);

  const getAll = (page, size) => {
    setLoading(true);
    AuditEventLogsRepository.getAll(
      page,
      size,
      filterParams,
      orderBy,
      orderDirection
    )
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching audit event logs:", error);
        dispatch(notifyShowErrorMessage(ErrorMessageResolver.resolve(error)));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleChangePage = (event, newPage) => {
    getAll(newPage, data?.size);
  };

  return (
    <PageLayout
      title="Аудит лог на настани"
      Icon={BsFiles}
      prev={location.pathname}
    >
      <Grid container style={{ padding: "10px 0" }}>
        <Grid item xs={12} sx={{ mb: 1 }}>
          <AuditEventsFilter
            filterParams={filterParams}
            setFilterParams={setFilterParams}
            applyFilters={() => getAll(0, 15)}
            loading={loading}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ padding: "10px 0", gap: "10px", display: "flex" }}
        >
          <AuditEventsTable
            data={data}
            loading={loading}
            handleChangePage={handleChangePage}
          />
        </Grid>
      </Grid>
    </PageLayout>
  );
};
